import { render, staticRenderFns } from "./SmsPortalLayout.vue?vue&type=template&id=2350f603"
import script from "./SmsPortalLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsPortalLayout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports